<template>
    <sa-page-layout :btnBackVisible="true" :linkback="linkback" :pathResource="pathResource" :showModalLoading="showModalLoading">
        <template slot="table-body">
            <!--      <rsa-accettazione-view-component ref="cmpRsaAccettazioneViewComponent" @beforeLoadData="onBeforeloadData" @afterLoadData="onAfterLoadData"></rsa-accettazione-view-component> -->
            <banca-farmaci-view-component ref="cmpBancaFarmaciView"></banca-farmaci-view-component>
        </template>
    </sa-page-layout>
</template>
<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import BancaFarmaciViewComponent from "../components/BancaFarmaciViewComponent.vue";

export default {
    components: { SaPageLayout, BancaFarmaciViewComponent },
    data() {
        return {
            btnNewVisible: false,
            pathResource: "",
            id: null,
            btnEditVisible: true,
            linkedit: null,
            linkback: "/bancafarmaci",
            linkPrintData: "",
            showModalLoading: false,
            listKey: 0,
        };
    },
    mounted() {
        let me = this;
        me.id = this.$route.params.id;
        this.init();
    },
    methods: {
        init() {
            let me = this;
            me.$refs.cmpBancaFarmaciView.init(me.id);
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onBeforeloadData() {
            let me = this;
            me.showModalLoading = true;
        },
    },
};
</script>
<style></style>
